import { useContext } from 'react';
import { COOKIE_STATUS, COOKIE_STATUS_DETAILS } from '../../constants/cookie';
import { useLanguageData } from '../../hooks/useLanguageData';
import CookieConsentManagement from './components/cookieConsentManagement/CookieConsentManagement';
import {
	ButtonAccept,
	ButtonDenied,
	ButtonWrapper,
	CookieWrapper,
	FlexTop,
	MiddleText,
	TopWrapper,
} from './CookieConsent.styles';
import { CookieContext } from '@/common/contexts/CookieContext';

const CookieConsent = () => {
	const {
		handleCookieDecision,
		cookieDetails,
		manageCookieConsent,
		setManageCookieConsent,
	} = useContext(CookieContext);
	const data = useLanguageData('cookie');

	const handleManageButton = (status) => {
		if (manageCookieConsent) {
			handleCookieDecision(status, cookieDetails);
		}
		setManageCookieConsent((prev) => !prev);
	};

	return (
		<>
			<CookieWrapper>
				<FlexTop>
					<TopWrapper>
						<div>{data.title}</div>
					</TopWrapper>
					<MiddleText>
						{data.subtitle}
						<a href='/privacy' target='_blank'>
							{data.link}
						</a>
						.
					</MiddleText>
				</FlexTop>
				{manageCookieConsent && <CookieConsentManagement />}
				<ButtonWrapper>
					<ButtonDenied
						onClick={() => handleCookieDecision(COOKIE_STATUS.DENAIED, [])}
					>
						{data.denied}
					</ButtonDenied>
					<ButtonDenied onClick={() => handleManageButton(COOKIE_STATUS.ALLOW)}>
						{manageCookieConsent ? data.saveChanges : data.manage}
					</ButtonDenied>
					<ButtonAccept
						onClick={() =>
							handleCookieDecision(COOKIE_STATUS.ALLOW, [
								COOKIE_STATUS_DETAILS.ANALYTICAL,
								COOKIE_STATUS_DETAILS.FUNCTIONAL,
								COOKIE_STATUS_DETAILS.MARKETING,
								COOKIE_STATUS_DETAILS.PERSONALIZATION,
							])
						}
					>
						{data.accept}
					</ButtonAccept>
				</ButtonWrapper>
			</CookieWrapper>
		</>
	);
};

export default CookieConsent;
